import { Backdrop, Box, Typography } from "@mui/material";
import { useEffect, useRef } from "react";
import { useIntl } from "react-intl";
import { Outlet } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { selectStateStatus } from "../../../features/questionnaire/questionnaireSlice";
import { logout, selectToken } from "../../../features/user/userSlice";
import { LoadingIndicator } from "../LoadingIndicator/LoadingIndicator";
import { style } from "../LoadingIndicator/LoadingIndicator.style";

const ProtectedRoute = () => {
  const status = useAppSelector(selectStateStatus);
  const token = useAppSelector(selectToken);
  const dispatch = useAppDispatch();
  const firstUpdate = useRef(true);
  const { formatMessage } = useIntl();

  // Check authentication status on page rerender
  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
    }
  }, [firstUpdate]);

  useEffect(() => {
    if (status === "failed") {
      dispatch(logout());
    }
  }, [dispatch, status, token]);

  if (firstUpdate.current) {
    return <LoadingIndicator isLoading={firstUpdate.current} />;
  } else if (!token) {
    return (
      <Backdrop open>
        <Box
          sx={[
            style,
            { flexDirection: "column", textAlign: "center", width: "40%" },
          ]}
          aria-live="assertive"
          maxWidth="360px"
        >
          <Typography
            id="expired-session-title"
            fontSize="1.5rem"
            variant="h1"
            fontWeight="400"
            marginBottom="24px"
          >
            {formatMessage({ id: "authProtectedRoute.header" })}
          </Typography>
          <Typography
            id="expired-session-body"
            paragraph
            variant="body1"
            color="#272727"
          >
            {formatMessage({ id: "authProtectedRoute.body" })}
          </Typography>
        </Box>
      </Backdrop>
    );
  }

  // returns child route elements
  return <Outlet />;
};

export default ProtectedRoute;
